/**
 * edj-article-toc.js — Lot 7 Batch D EDJ
 * Génération auto de la TOC article (sidebar desktop) depuis les <h2> du contenu,
 * + scroll-spy pour mettre en évidence l'item actif.
 *
 * Custom element <edj-article-toc data-target=".edj-article-content">
 *   <div class="edj-article__sidebar-inner">
 *     <div class="edj-article__sidebar-label">Sommaire</div>
 *     <ul class="edj-article__toc"></ul>
 *   </div>
 * </edj-article-toc>
 *
 * Si aucun h2 trouvé → l'élément masque sa propre liste (DOM-safe).
 */
(function () {
  'use strict';

  if (customElements.get('edj-article-toc')) return;

  function slugify(text) {
    return (text || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '')
      .slice(0, 60);
  }

  class EdjArticleTOC extends HTMLElement {
    connectedCallback() {
      var selector = this.getAttribute('data-target') || '.edj-article-content';
      var content = document.querySelector(selector);
      if (!content) return;

      var headings = content.querySelectorAll('h2');
      var list = this.querySelector('.edj-article__toc');
      if (!list) return;

      // vide la liste de manière DOM-safe
      while (list.firstChild) list.removeChild(list.firstChild);

      if (!headings.length) {
        this.style.display = 'none';
        return;
      }

      var seen = {};
      var items = [];
      Array.prototype.forEach.call(headings, function (h2, i) {
        var id = h2.id || slugify(h2.textContent || ('section-' + (i + 1)));
        if (seen[id]) id = id + '-' + (i + 1);
        seen[id] = true;
        h2.id = id;

        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + id;
        a.textContent = h2.textContent || ('Section ' + (i + 1));
        a.setAttribute('data-toc-link', id);
        li.appendChild(a);
        list.appendChild(li);
        items.push({ id: id, link: a, h2: h2 });
      });

      // scroll-spy via IntersectionObserver
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var id = entry.target.id;
            var link = list.querySelector('[data-toc-link="' + id + '"]');
            if (!link) return;
            if (entry.isIntersecting) {
              items.forEach(function (it) {
                it.link.classList.remove('is-active');
              });
              link.classList.add('is-active');
            }
          });
        },
        { rootMargin: '0px 0px -60% 0px', threshold: 0 }
      );
      items.forEach(function (it) {
        io.observe(it.h2);
      });

      // lien click smooth
      list.addEventListener('click', function (e) {
        var t = e.target;
        if (t && t.tagName === 'A' && t.hash) {
          var target = document.getElementById(t.hash.slice(1));
          if (target) {
            e.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            history.replaceState(null, '', t.hash);
          }
        }
      });
    }
  }

  customElements.define('edj-article-toc', EdjArticleTOC);
})();
